import urlFile from "../common/ApiFile"
import url from "../common/api"
import {getQueries} from "../queries/getQueries.js"
import {postQueries} from "../queries/postQueries"
import {patchQueries} from "../queries/patchQueries"


var data=JSON.parse(sessionStorage.getItem("authAshia"))?.profile

export async function getLanguageList(){
    var datas=[]
    await getQueries("langues").then(data=>{
        data.map((element)=>{
           datas= [...datas,{value:element.id,label:element.nom,evenements:element.evenements,ressources:element.ressources,utilisateurs:element.utilisateurs.filter(e=>e.fonction=="EXPERT")}]
        })
    })
    
    return await datas
}

export async function getProfileRessource(id){
    var datas={}
    var expert=[]
    var ressource=[]
    var event=[]

    var data=[id]

    // if(localStorage.getItem("private_id") && localStorage.getItem("private_id")!==id){
    //      data.push(localStorage.getItem("private_id"))
    // }

    console.log("puplic",localStorage.getItem("private_id"))
    await getQueries("profiles/"+id).then(async(data)=>{
       datas=data;
       if(localStorage.getItem("private_id") && localStorage.getItem("private_id")!==id){
        console.log("private user")
        await getQueries("profiles/"+localStorage.getItem("private_id")).then(data2=>{
           let data_event=data.evenements.concat(data2?.evenements)  
           let data_ress=data.ressources.concat(data2?.ressources)
           let data_exp=data.utilisateurs.concat(data2?.utilisateurs)

           data2.evenements=_.uniqBy(data_event,"id")
           data2.ressources=_.uniqBy(data_ress,"id")
           data2.utilisateurs=_.uniqBy(data_exp,"id")

           datas=data2
        })
       }
    })

    // await postQueries("ressource/searchRessource",data).then(res=>{
    //     ressource=_.uniqBy(res,"id")
    //     datas['ressources']=ressource
    // })

    // await postQueries("utilisateur/searchExpert",data).then(res=>{
    //     expert=_.uniqBy(res,"id")
    //     datas['utilisateurs']=expert

    // })
    // await postQueries("evenement/searchEvenement",data).then(res=>{
    //     event=_.uniqBy(res,"id")
    //     datas['evenements']=event

       
    // })
    
    return await datas
}


export async function getSisDescription(){
    var datas=[]
    await getQueries("ses").then(data=>{
       datas=data;
    })
    
    return await datas
}

// export  getLangue

export async function removeElement(data,url){
    var datas={}
    await postQueries(url,data).then(res=>{
        //datas=res
    })
   // return await datas
}

export async function getRessourceByUser(data){
    var datas=[]
    await postQueries("ressource/getRessourceByUser",data).then(res=>{
        datas=res
 
       
    })
   return await datas
}


export async function getRessourceByProfile(data){
    var datas=[]
    await postQueries("ressource/getRessourceByProfile",data).then(async (res)=>{
        datas=res

        if(localStorage.getItem("private_id") && localStorage.getItem("private_id")!==data?.profile_id ){
            await getQueries("profiles/"+localStorage.getItem("private_id")).then(data2=>{
                let data_ress=res.concat(data2?.ressources)
                datas=_.uniqBy(data_ress,"id")
                
            })
          }
           
       
    })
   return await datas
}

export async function getRessourceBySearch(data){
    var datas=[]
    await postQueries("ressource/searchRessource",data).then(res=>{
        datas=res
       
    })
   return await datas
}


export async function removeElements(data,url){
    var datas={}
    for(var i=0;i<data.length;i++){
    await postQueries(url,data[i]).then(res=>{
       
    })
   }
    
}

export async function updateRessource(data){
    var datas={}
    const id=sessionStorage.getItem("idressource")
    await patchQueries("ressources/"+id,data).then(res=>{
        datas=res
    })
    return await datas
}

export async function updateVote(data,id){
    var datas={}
   
    await patchQueries("votes/"+id,data).then(res=>{
        datas=res
    })
    return await datas
}


export async function removeUniteAdministrativeInRessource(unites,idRessource){
   if(unites.length) {
    for(var i=0;i<unites.length;i++){
        await postQueries("ressource_unite_administrative/delete",{"ressource_id":idRessource,"unite_administrative_id":unites[i].id}).then(res=>{
         
        })
       }
   }
}

export async function removeSousTypeInRessource(sous_types,idRessource){
if(sous_types.length) {
    for(var i=0;i<sous_types.length;i++){
        await postQueries("ressource_sous_ressource/delete",{"ressource_id":idRessource,"sous_type_ressource_id":sous_types[i].id}).then(res=>{
        
        })
    }
}
     
    
}
  
        